import React from 'react';
import { ShieldCheck, AlertTriangle, AlertOctagon, CheckCircle2, MinusCircle, Ban, Lock } from 'lucide-react';

const MAP = {
  critical: { bg: 'bg-red-50', text: 'text-apex-critical', border: 'border-red-200', icon: AlertOctagon, label: 'CRITICAL' },
  high: { bg: 'bg-amber-50', text: 'text-apex-warning', border: 'border-amber-200', icon: AlertTriangle, label: 'HIGH' },
  medium: { bg: 'bg-amber-50/60', text: 'text-apex-warning', border: 'border-amber-200', icon: AlertTriangle, label: 'MEDIUM' },
  low: { bg: 'bg-slate-100', text: 'text-apex-neutral', border: 'border-slate-200', icon: MinusCircle, label: 'LOW' },
  enforced: { bg: 'bg-emerald-50', text: 'text-apex-success', border: 'border-emerald-200', icon: CheckCircle2, label: 'ENFORCED' },
  gap: { bg: 'bg-red-50', text: 'text-apex-critical', border: 'border-red-200', icon: Ban, label: 'GAP' },
  bypassed: { bg: 'bg-amber-50', text: 'text-apex-warning', border: 'border-amber-200', icon: Lock, label: 'BYPASSED' },
};

export default function SeverityBadge({ severity = 'low', size = 'md', icon = true, className = '' }) {
  const cfg = MAP[severity] ?? MAP.low;
  const Icon = cfg.icon;
  const sz = size === 'sm' ? 'text-[10px] px-1.5 py-0.5 gap-1' : 'text-[11px] px-2 py-1 gap-1.5';
  return (
    <span
      data-testid={`severity-badge-${severity}`}
      className={`inline-flex items-center font-semibold tracking-wider rounded border ${cfg.bg} ${cfg.text} ${cfg.border} ${sz} ${className}`}
    >
      {icon && <Icon className="w-3 h-3" strokeWidth={2.5} />}
      {cfg.label}
    </span>
  );
}
